import _ from 'lodash';
import TokenStore from '../stores/TokenStore';
import CookieHelper from '../helpers/Cookie';
import FeatureFlagStore from '../stores/FeatureFlagStore';
import OrderStore from '../stores/OrderStore';
import { CookieKeys } from '../constants/AppConstants';
import { toBase64Utf8 } from './fp-utils';

const getOrderCookieJourneys = (currentOrder) => {
    return currentOrder.trips.reduce((acc, orderTrip) => {
        const fares = orderTrip.getJourneyFares();

        fares.forEach(fare => {
            const journey = {
                id: orderTrip.id,
                isReturn: orderTrip.isReturn(),
                ticketType: fare.ticketType.name,
                adults: fare.adults(),
                children: fare.children(),
                railcards: fare.getRailcards().map(r => r.name).toJS(),
                restrictions: fare.getDescription(),
                price: fare.getTotalPrice(),
                origin: _.get(fare, 'origin.name') || _.get(fare, 'outwardJourney.getOrigin().name'),
                destination: _.get(fare, 'destination.name') || _.get(fare, 'outwardJourney.getDestination().name'),
            };

            const returnJourney = orderTrip.isReturn() && acc.find(({ id }) => id === orderTrip.id);
            if (returnJourney) {
                acc = acc.map(outboundJourney => outboundJourney.id === orderTrip.id ? ({
                    ...outboundJourney,
                    originReturn: journey.origin,
                    destinationReturn: journey.destination,
                    ticketTypeReturn: journey.ticketType,
                    restrictionsReturn: journey.restrictions,
                    price: journey.price + outboundJourney.price,
                    railcards: _.union(outboundJourney.railcards, journey.railcards),
                }) : outboundJourney);
            } else {
                acc = [...acc, journey];
            }
        });
        return acc;
    }, []);
};

const prepareOrderCookie = (currentOrder) => {
    return {
        id: currentOrder.id,
        totalPrice: currentOrder.totalPrice,
        journeysAmount: currentOrder.trips.size,
        journeys: getOrderCookieJourneys(currentOrder),
    };
};

export const updateOrderCookie = (order) => {
    if (!FeatureFlagStore.get('enableBasketWidget')) {
        return false;
    }
    const currentOrder = OrderStore.getCurrent();

    const orderData = {
        device: TokenStore.getDevice(),
        order: _.isPlainObject(order) ? order : prepareOrderCookie(currentOrder),
    };

    try {
        // JSON validity check
        const json = JSON.stringify(orderData);
        JSON.parse(json);

        // UTF-8–safe Base64
        const b64 = toBase64Utf8(json);

        // Size guard to prevent truncated/invalid cookies
        if (b64.length > CookieHelper.MAX_COOKIE_CHARS) {
            console.warn('Refusing to set order cookie: too large', {
                size: b64.length, cap: CookieHelper.MAX_COOKIE_CHARS,
                journeys: _.get(orderData, 'order.journeys.length')
            });
            return false;
        }

        CookieHelper.set(CookieKeys.ORDER, b64, {}, false);
        return true;
    } catch (error) {
        console.error('Refusing to set order cookie: invalid payload/encoding', error, { orderData });
        CookieHelper.clear(CookieKeys.ORDER);
        return false;
    }
};
